module.exports = __webpack_public_path__ + "static/media/video.02d08739.mp4";